/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateInternshipApplication } from '../../models/create-internship-application';
import { InternshipApplication } from '../../models/internship-application';

export interface CreateInternshipApplication$Params {
  profileId: string;
      body?: CreateInternshipApplication
}

export function createInternshipApplication(http: HttpClient, rootUrl: string, params: CreateInternshipApplication$Params, context?: HttpContext): Observable<StrictHttpResponse<InternshipApplication>> {
  const rb = new RequestBuilder(rootUrl, createInternshipApplication.PATH, 'post');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InternshipApplication>;
    })
  );
}

createInternshipApplication.PATH = '/studentprofile/{profileId}/internshipapplications';
